"use client";

import styled from "styled-components";

//Components
import Button from "../button";
import Link from "next/link";

const hoverColors: Record<string, string> = {
  red: "#FF4D4F",
  green: "var(--primarySystem100)",
  blue: "#1890FF",
};

interface ButtonIconProps {
  $hovercolor?: "red" | "green" | "blue";
}

export const ButtonIcon = styled.button<ButtonIconProps>`
  background: var(--background);
  padding: 6px;
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;

  svg {
    width: 16px;
    height: 16px;
    stroke: var(--textLight);
    transition: all 0.2s ease;
  }

  &:hover {
    background: ${({ $hovercolor }) =>
      $hovercolor === "red"
        ? "rgba(255, 77, 79, 0.1)"
        : $hovercolor === "green"
          ? "rgba(34, 197, 94, 0.1)"
          : $hovercolor === "blue"
            ? "rgba(24, 144, 255, 0.1)"
            : "var(--grayCard)"};
    border-color: ${({ $hovercolor }) =>
      $hovercolor ? hoverColors[$hovercolor] : "var(--border)"};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    svg {
      stroke: ${({ $hovercolor }) =>
        $hovercolor ? hoverColors[$hovercolor] : "var(--textLight)"};
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(0);
  }
`;

export const LinkIcon = styled(Link)<ButtonIconProps>`
  background: var(--background);
  padding: 6px;
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  text-decoration: none;

  svg {
    width: 16px;
    height: 16px;
    stroke: var(--textLight);
    transition: all 0.2s ease;
  }

  &:hover {
    background: ${({ $hovercolor }) =>
      $hovercolor === "red"
        ? "rgba(255, 77, 79, 0.1)"
        : $hovercolor === "green"
          ? "rgba(34, 197, 94, 0.1)"
          : $hovercolor === "blue"
            ? "rgba(24, 144, 255, 0.1)"
            : "var(--grayCard)"};
    border-color: ${({ $hovercolor }) =>
      $hovercolor ? hoverColors[$hovercolor] : "var(--border)"};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    svg {
      stroke: ${({ $hovercolor }) =>
        $hovercolor ? hoverColors[$hovercolor] : "var(--textLight)"};
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(0);
  }
`;
